import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=aad4af02&scoped=true"
import script from "./Banks.ts?vue&type=script&lang=js&external"
export * from "./Banks.ts?vue&type=script&lang=js&external"
import style0 from "./Banks.vue?vue&type=style&index=0&id=aad4af02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad4af02",
  null
  
)

export default component.exports